// https://github.com/hotwired/turbo/issues/37#issuecomment-1169195154
import { Controller } from '@hotwired/stimulus';
import { freezeScrollOnNextRender } from 'src/lib/scroll_freeze';

export default class extends Controller {
  static values = {
    target: String,
  };

  click() {
    let selector = null;

    if (this.hasTargetValue) {
      selector = this.targetValue;
    }

    freezeScrollOnNextRender(selector);
  }
}
